<template>
  <div>
    <!-- TODO: Remove `pt:label:class` -->
    <Button
      ref="button"
      type="button"
      severity="secondary"
      outlined
      class="!p-0"
      pt:label:class="hidden"
      @click="togglePopover"
    >
      <template
        v-if="selectedIconInformation"
        #icon
      >
        <Emoji
          v-if="selectedIconInformation?.type === 'emoji'"
          :data="emojiIndex"
          :emoji="selectedIconInformation.value"
          set="apple"
          :size="24"
        />
      </template>
    </Button>

    <!-- TODO: Manage base z-index -->
    <Popover
      ref="popover"
      :base-z-index="1234236"
    >
      <Picker
        :data="emojiIndex"
        set="apple"
        color="#09090b"
        :show-preview="false"
        @select="handleEmojiSelect"
      />
    </Popover>
  </div>
</template>

<script lang="ts" setup>
import { Emoji, Picker, EmojiIndex } from 'emoji-mart-vue-fast/src'
import data from 'emoji-mart-vue-fast/data/apple.json'
import 'emoji-mart-vue-fast/css/emoji-mart.css'

const emit = defineEmits(['select'])

const popover = useTemplateRef<any>('popover')
const togglePopover = (event: Event) => {
  popover.value!.toggle(event)
}

const emojiIndex = new EmojiIndex(data)
const selectedIconInformation = defineModel<{ type: string, value: string } | null>()
const handleEmojiSelect = (emoji: any) => {
  const value = { type: 'emoji', value: emoji.id }
  selectedIconInformation.value = value
  emit('select', value)
  togglePopover(new Event('click'))
}

onMounted(() => {
  if (!selectedIconInformation.value) {
    const emojiKeys = Object.keys(data.emojis)
    const randomKey = emojiKeys[Math.floor(Math.random() * emojiKeys.length)]
    handleEmojiSelect({ id: randomKey })
  }
})
</script>
